import "./login.css";
import { Card } from "@bootstrap-styled/v4";
import { OKOFooter } from "../../OKOFooter";
import { colors } from "utils";
import styled from "styled-components";

export const LoginCard = ({ children, borderRadius = 0.75, maxWidth = 450 }) => {
  return (
    <Container $maxWidth={maxWidth}>
      <Content $borderRadius={borderRadius} $maxWidth={maxWidth}>
        {children}
      </Content>
      <OKOFooter />
    </Container>
  );
};

const Container = styled.div`
  background-color: ${colors.milkGlass200};
  width: 100%;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  position: relative;
  z-index: 1;
`

const Content = styled(Card)`
  border: none !important;
  border-radius: ${({ $borderRadius }) => $borderRadius}rem !important;
  display: flex;
  min-height: 350px;
  height: fit-content;
  justify-content: center;
  margin: auto;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  width: 100%;
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
